import api from "./axios";
import { paths } from "./paths";

export const downloadCsv = async () => {
  const response = await api.get(paths.export.playersCsv, {
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "player-statistics.csv");
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};
